<template>
  <article class="live-card">
    <div class="live-card__head">
      <span>{{ label }}</span>
      <span v-if="live" class="live-card__badge">
        <i />
        LIVE
      </span>
    </div>
    <div class="live-card__value">
      {{ value }}
      <small v-if="unit">{{ unit }}</small>
    </div>
    <div v-if="caption" class="live-card__caption">{{ caption }}</div>
  </article>
</template>

<script>
export default {
  name: 'LiveMetricCard',
  props: {
    label: { type: String, required: true },
    value: { type: [String, Number], required: true },
    unit: { type: String, default: '' },
    caption: { type: String, default: '' },
    live: { type: Boolean, default: false }
  }
}
</script>

<style scoped>
.live-card {
  padding: 18px 22px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.07);
  backdrop-filter: blur(8px);
  transition: 0.18s ease;
}

.live-card:hover {
  transform: translateY(-2px);
  background: rgba(255, 255, 255, 0.15);
}

.live-card__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  color: rgba(255, 255, 255, 0.66);
  font-size: 12.5px;
}

.live-card__badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 2px 9px;
  color: #9fe8c3;
  border-radius: 999px;
  background: rgba(18, 183, 106, 0.22);
  font-size: 10.5px;
  font-weight: 800;
}

.live-card__badge i {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #12b76a;
  animation: up-pulse 1.2s ease infinite;
}

.live-card__value {
  margin-top: 6px;
  color: #fff;
  font-size: 26px;
  font-variant-numeric: tabular-nums;
  font-weight: 800;
}

.live-card__value small {
  color: rgba(255, 255, 255, 0.66);
  font-size: 13px;
  font-weight: 600;
}

.live-card__caption {
  margin-top: 4px;
  color: #9fe8c3;
  font-size: 11.5px;
}
</style>
